import { RcClasses } from '../../../../foundation';
export var RcCircularProgressClasses = RcClasses([], 'RcCircularProgress');
